var render = function render(_c,_vm){return _c('div',{staticClass:"C-fragment C-fragment-html",class:[
    `C-fragment-html--${_vm.props.content.type}`,
    { 'C-fragment-html--bullet_list--liedetector': _vm.props.content.html.includes('<li>Šaltiniai</li>') || _vm.props.content.html.includes('<li>Источники</li>') },
  ],domProps:{"innerHTML":_vm._s(_vm.props.content.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }